import { z } from 'zod'
import type { Hex } from '../../types'
import { addressPrimitiveSchema, lowerHexSchema } from '../../types/primitive'
import type { HeadersInput } from '../types'
import type { ContractCreation } from '../types'
import type { RoutescanClient } from './client'

type GetContractCreatorAndCreationTxHashParameters = {
  client: RoutescanClient
  contractaddresses: Hex[]
  headers?: HeadersInput
}

const contractCreationSchema = z.object({
  contractAddress: addressPrimitiveSchema,
  contractCreator: addressPrimitiveSchema,
  txHash: lowerHexSchema,
})
const resultSchema = z.array(contractCreationSchema)

/** {@link https://docs.etherscan.io/routescan/api-endpoints/contracts#get-contract-creator-and-creation-tx-hash} */
export const getContractCreatorAndCreationTxHash = async ({
  client,
  contractaddresses,
  headers,
}: GetContractCreatorAndCreationTxHashParameters): Promise<
  ContractCreation[]
> => {
  try {
    const result = await client.get({
      path: '',
      query: {
        module: 'contract',
        action: 'getcontractcreation',
        contractaddresses: contractaddresses.join(','),
      },
      resultSchema,
      headers,
    })
    return result
  } catch (error) {
    if (error instanceof Error && error.message.includes('No data found')) {
      return []
    }
    throw error
  }
}
